import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "./AuthProvider";

type Profile = {
  id: string;
  email: string;
  created_at?: string;
  role?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  organization_id?: string | null;
};

const ProfileContext = createContext<{
  profile: Profile | null;
  loading: boolean;
  org: null;
  refreshProfile: () => void;
}>({
  profile: null,
  loading: true,
  org: null,
  refreshProfile: () => {},
});

export const ProfileProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    if (!user?.id) return;

    setLoading(true);

    const { data, error } = await supabase
      .from("profiles")
      .select(
        `
        *
        
      `
      )
      .eq("id", user.id)
      .single();
    if (!error && data) {
      setProfile({
        id: data.id,
        email: data.email,
        first_name: data?.first_name || "",
        last_name: data?.last_name || "",
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      if (!user?.id) return;
      await fetchProfile();
    };
    init();
  }, [user?.id]);

  return (
    <ProfileContext.Provider
      value={{ profile, loading, refreshProfile: fetchProfile }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => useContext(ProfileContext);
